import { useEffect } from 'react';
import { restoreSession } from '@/features/auth/store/auth.slice';
import { useAppDispatch } from '@/shared/store/hooks';

/**
 * SOĞUK AÇILIŞ: sayfa yenilendiğinde oturum HttpOnly çerezden diriltilir.
 *
 * Kapı `bootstrapped` bayrağını bekler; bu bileşen olmasa panel her açılışta
 * sonsuza kadar iskelet çizerdi. Tek sefer çalışır ve sonucu ne olursa olsun
 * bayrağı düşürür (`success(null)` da `failure` da `bootstrapped: true` yazar).
 */
export function SessionBootstrap() {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(restoreSession.request());
  }, [dispatch]);
  return null;
}
